import React from 'react';
import ImageTextBlock from './ImageTextBlock';

const Home: React.FC = () => (
  <section className="page-content">
    <h2>Home</h2>
    <ImageTextBlock
      imageSrc="/images/workshop_surface.jpg"
      imageAlt="Violin on the workbench"
      title="Colin Skofield, Luthier"
      text="Fine violin and viol family instruments, handcrafted by myself and others. Repair and restoration services for modern and baroque instruments."
      buttonText="Contact Me"
      buttonLink="/contact"
    />
    <ImageTextBlock
      imageSrc="/images/forsale.png"
      imageAlt="Collage of instruments for sale"
      title="Instruments For Sale"
      text="I am currently offering a 5-String Cello and a baroque-style violin for sale."
      buttonText="See Instruments"
      buttonLink="/forsale"
      reverse
    />
    <ImageTextBlock
      imageSrc="/images/colin_portrait_landscape.jpg"
      imageAlt="Portrait of Colin Skofield"
      title="Why Work with Me"
      text="I take special pride in running a one man operation, I employ no apprentices or outsource work to contractors. When working with me, you can be guaranteed a high degree of personal attention."
      buttonText="About Me"
      buttonLink="/about"
    />
  </section>
);

export default Home;